import "./scss/styles.scss";
import Navigation from "./site-components/navigation.js";
import Images from "./site-components/images.js";
import Slider from "./site-components/slider.js";
import axios from "axios";

window.onload = async () => {
  Navigation.init();
  Images.init();
  Slider.init();

  try {
    const notifications = await axios.get("/notifications.json");
    if (notifications && notifications.data && notifications.data.length) {
      notifications.data.forEach((notification) => {
        document.querySelectorAll(".site-navigation").forEach((el) => {
          const notificationEl = document.createElement("div");
          notificationEl.classList.add("popup-notification");
          notificationEl.classList.add(notification.type);
          notificationEl.innerHTML = notification.text;
          el.appendChild(notificationEl);
        });
      });
    }
  } catch (e) {
    console.log(e);
  }

  const form = document.querySelector("form");

  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      let formData = {};
      let fields = 0;
      let url = form.getAttribute("action");
      for (let i = 0, element; (element = form.elements[i++]); ) {
        if (element.value !== "" && element.name) {
          formData[element.name] = element.value;
        }
        if (element.name) {
          fields++;
        }
      }
      if (
        (fields == Object.keys(formData).length,
        { "Content-Type": "text/html" })
      ) {
        document.querySelector("form .btn").style.display = "none";
        document.querySelector("form .loader").style.display = "block";
        console.log(formData);
        axios.post(url, formData).then(() => {
          form.classList.add("success");
        });
      }
    });
  }
};

window.onscroll = () => {
  Navigation.scroll();
};
